/**
 * StatusPill — Property-Lifecycle-Status (Sprint-16-Brand).
 *
 * Live: sage-tint mit gefülltem sage-Dot (matches Mockup 4c ● Live).
 * Paused/Draft/Archived: Sprint-16-Pill-Varianten.
 */
import { Pill } from '@/shared/components';
import type { PropertyLifecycleStatus } from '@/shared/api';

export function StatusPill({ status }: { status: PropertyLifecycleStatus }) {
  switch (status) {
    case 'Active':
      return (
        <Pill variant="live" size="sm">
          <span className="bg-sage size-1.5 rounded-full" aria-hidden />
          Live
        </Pill>
      );
    case 'Paused':
      return (
        <Pill variant="warning" size="sm">
          Pausiert
        </Pill>
      );
    case 'Draft':
      return (
        <Pill variant="outline" size="sm">
          Entwurf
        </Pill>
      );
    case 'Archived':
      return (
        <Pill variant="default" size="sm">
          Archiviert
        </Pill>
      );
  }
}
